/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */

define('modules/Product/UnitsOfMeasure',[
    'jquery',
    'lodash',
    'global/all',
    'modules/Delivery/PriceAndDeliveryOptions'
], function ($, _, Roc, PriceAndDeliveryOptions) {
    'use strict';

    var selectors = {
        unitsOfMeasurePanel: '#unitsOfMeasure',
        selectedUnitOfMeasure: '#selectedUom'
    };

    /**
     * When simple product is loaded from cart, the page first loads the group product,
     * and then applies the selection to the selector controls in order to pick the simple which was added to cart.
     * In this scenario, we cannot simply set the selected UOM immediately. It needs to happen AFTER a simple product is selected.
     *
     * This field is to be used STRICTLY in this scenario.
     */
    var uomToSelectWhenSimpleProductIsChosen;

    // getUnitsOfMeasureInfoForProduct(productId) returns an object 
    // containing unit of measure info ready for rendering in the unitsOfMeasure-Tmp template.
    function getUnitsOfMeasureInfoForProduct(productViewModel, uomToSelect) {
        if (productViewModel) {
            var units = productViewModel.availableUnitsOfMeasure;
            var unitToSelect = null;

            // The logic for selecting a unit is a bit complex, and works like this:
            // If the caller decided to force a unit selection, we can respect that, if there is a unit like that
            if (uomToSelect && unitExists(units, uomToSelect)) {
                unitToSelect = uomToSelect;
                console.log("Selecting explicitly chosen unit:" + unitToSelect);
            }

            // If there was no explicit selection made, let's try selecting the unit associated with product pricing
            if (!unitToSelect) {
                if (productViewModel.productPricing && productViewModel.productPricing.unitOfMeasure) {
                    var pricingUnit = productViewModel.productPricing.unitOfMeasure.id;

                    if (pricingUnit && unitExists(units, pricingUnit)) {
                        unitToSelect = pricingUnit;
                        console.log("Selecting pricing unit:" + unitToSelect);
                    }
                }
            }

            // if that did not work, next in line is the currently selected unit
            if (!unitToSelect) {
                var currentlySelectedUnit = getCurrentlySelectedUnitId();
                if (currentlySelectedUnit && unitExists(units, currentlySelectedUnit)) {
                    unitToSelect = currentlySelectedUnit;
                    console.log("Selecting previously selected unit:" + unitToSelect);
                }
            }

            // next: check if there is a default unit specified on product
            if (!unitToSelect) {
                var productDefaultUnit = productViewModel.unitOfMeasure;
                if (productDefaultUnit && unitExists(units, productDefaultUnit)) {
                    unitToSelect = productDefaultUnit;
                    console.log("Selecting product default unit:" + unitToSelect);
                }
            }

            // as a final attempt to find a unit let's get the one which is marked as default
            if (!unitToSelect) {
                var defaultUnits = _.filter(units,
                    function(unit) {
                        return unit.isBaseUnit;
                    });
                
                if (defaultUnits.length > 0) {
                    unitToSelect = defaultUnits[0].id;
                    console.log("Selecting base unit:" + unitToSelect);
                }
            }

            return {
                productId: productViewModel.id,
                unitsOfMeasure: units,
                selectedUomId: unitToSelect
            };
        }
        return null;
    }

    function unitExists(units, uomId) {
        return _.some(units,
            function (unit) {
                return unit.id === uomId;
            });
    }

    function reloadAvailableUnitsOfMeasure(productViewModel) {
        var previouslySelectedUnit = getCurrentlySelectedUnitId();
        var units = getUnitsOfMeasureInfoForProduct(productViewModel, uomToSelectWhenSimpleProductIsChosen);
        uomToSelectWhenSimpleProductIsChosen = null; // this selection should only happen once, so clear the value
        render(units).then(function() {
            if (previouslySelectedUnit !== units.selectedUomId) {
                processUnitChangeEvent();
            }
        });
    }

    function render(options) {
        return Roc.UI.renderFormTemplate('unitsOfMeasure-Tmp', options, $(selectors.unitsOfMeasurePanel));
    }

    function bindUnitChange() {
        Roc.UI.siteBody
            .off('change', selectors.selectedUnitOfMeasure)
            .on('change', selectors.selectedUnitOfMeasure, function () {
                processUnitChangeEvent();
            });
    }

    function processUnitChangeEvent() {
        var $uom = $(selectors.selectedUnitOfMeasure);
        var productId = $uom.attr('data-roc-productId');
        PriceAndDeliveryOptions.reloadPriceAfterSelection({ id: productId });
    }

    function getCurrentlySelectedUnitId() {
        return $(selectors.selectedUnitOfMeasure).val() || "";
    }

    function bindEvents() {
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadAvailableUnitsOfMeasure);
        bindUnitChange();
    }

    function init(options) {
        if (options && options.uomId) {
            if (!options.hasSelections) {
                $(selectors.selectedUnitOfMeasure).val(options.uomId);
                processUnitChangeEvent();
            } else {
                uomToSelectWhenSimpleProductIsChosen = options.uomId;
            }
        }

        bindEvents();
    }

    var UnitsOfMeasure = {
        init: init,
        getUnitsOfMeasureInfoForProduct: getUnitsOfMeasureInfoForProduct
    };

    Roc.Logger.debug('UnitsOfMeasure.js Loaded:', UnitsOfMeasure);

    return UnitsOfMeasure;
});
